import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCandidateUncertaintyIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeWidth: 4,
		children: [
			/* @__PURE__ */ _jsx("line", {
				x1: 2,
				x2: 2,
				y1: 0,
				y2: 24
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 0,
				x2: 24,
				y1: 12,
				y2: 12
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 22,
				x2: 22,
				y1: 0,
				y2: 24
			})
		]
	})
});
export default SvgCandidateUncertaintyIcon;
